module.exports = __webpack_public_path__ + "static/media/craver.3a07561c.jpg";